import { ComponentType } from '@angular/cdk/portal';
import {
  AfterViewInit,
  Component,
  HostBinding,
  Inject,
  Input,
  Optional,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DestroyService } from '../../../shared/destroy.service';
import { FormDialogData } from '../../../table/form-dialog.model';
import { FormContainerComponent } from '../form-container.component';
import { Is } from '../../../utils/is';

@Component({
  selector: 'core-form-dialog',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.scss'],
  providers: [DestroyService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormDialogComponent<T> extends FormContainerComponent implements AfterViewInit {
  @HostBinding('class.core-dialog') someClass = true;
  @Input() minWidth = '70vw';
  @Input() maxWidth: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public matDialogData: FormDialogData<T>,
    @Optional() public dialogRef: MatDialogRef<ComponentType<any>>
  ) {
    super();
  }

  override ngAfterViewInit(): void {
    this.updatePosition();
    super.ngAfterViewInit();
  }

  get dialogStyle(): { minWidth: string; width?: string; maxWidth?: string } {
    let minWidth = 642;
    if (!Is.empty(this.minWidth)) {
      if (this.minWidth.includes('vw') || this.minWidth.includes('%')) {
        const factor = parseFloat(this.minWidth) / 100;
        const resolvedPx = this.minWidth.includes('vw')
          ? factor * window.innerWidth
          : factor * document.body.clientWidth;
        minWidth = Math.round(resolvedPx);
      } else {
        minWidth = parseInt(this.minWidth, 10);
      }
    }

    const clientWidth = document.body.clientWidth;
    if (clientWidth < minWidth) {
      minWidth = clientWidth - 20;
    }
    if (this.maxWidth) {
      minWidth = Math.min(minWidth, parseInt(this.maxWidth, 10));
    }
    return {
      minWidth: `${minWidth}px`,
      width: `${minWidth}px`,
      ...(this.maxWidth ? { maxWidth: this.maxWidth } : {}),
    };
  }

  updatePosition(): void {
    const dialogElement = document.getElementById(this.dialogRef.id);
    if (dialogElement) {
      const panel: HTMLDivElement = dialogElement.closest('.cdk-overlay-pane');
      const keys = Object.keys(this.dialogStyle);
      for (const key of keys) {
        panel.style[key] = this.dialogStyle[key] as string;
      }
    }
  }
}
